import { useDispatch, useSelector } from "react-redux";
import { updateEnvironment } from "../../../actions/environment.action";
import { renderNextQuestion } from "../../../utilities/LiveChat";
import LinearProgress from '@mui/material/LinearProgress';
import { useEffect, useState } from "react";
import CancelIcon from '@mui/icons-material/Cancel';
import OpenInFullIcon from '@mui/icons-material/OpenInFull';
import CloseFullscreenIcon from '@mui/icons-material/CloseFullscreen';


export const Iframe = (props: any) => {
  const dispatch = useDispatch();
  const { label, source, iframeTitle, justHide } = props;
  const [isFrameLoaded, setIsFrameLoaded] = useState(false);
  const design = useSelector((state: any) => state?.design);
  const environment = useSelector((state: any) => state?.environment);
  const [screenSize, setScreenSize] = useState<'expanded' | 'collapsed'>('collapsed');

  const handleClick = () => {
    if (justHide) {
      dispatch(updateEnvironment({ iframeActive: {} }));
    } else {
      renderNextQuestion();
    }
  }

  const frameLoaded = () => {
    setIsFrameLoaded(true);
  }

  const toggleScreenSize = () => {
    const screen = screenSize === 'collapsed' ? 'expanded' : 'collapsed';
    setScreenSize(screen);
    if (screen === 'expanded') {
      window.parent.postMessage({ origin: 'BotPenguin', action: 'ele-expand' }, '*');
    } else {
      window.parent.postMessage({ origin: 'BotPenguin', action: 'ele-collapse' }, '*');
    }

  }

  useEffect(() => {

    return () => {
      window.parent.postMessage({ origin: 'BotPenguin', action: 'ele-collapse' }, '*');
    };
  }, []);



  useEffect(() => {
    function getLuminance(rgb: any) {
      // Convert RGB to relative luminance (https://en.wikipedia.org/wiki/Relative_luminance)
      let [r, g, b] = rgb.match(/\d+/g).map(Number);
      r /= 255;
      g /= 255;
      b /= 255;
      r = r <= 0.03928 ? r / 12.92 : Math.pow((r + 0.055) / 1.055, 2.4);
      g = g <= 0.03928 ? g / 12.92 : Math.pow((g + 0.055) / 1.055, 2.4);
      b = b <= 0.03928 ? b / 12.92 : Math.pow((b + 0.055) / 1.055, 2.4);
      return 0.2126 * r + 0.7152 * g + 0.0722 * b;
    }

    const element: any = document.getElementById('dynamicText');

    if (element) {

      const bgColor = getComputedStyle(element).backgroundColor;
      const luminance = getLuminance(bgColor);

      if (luminance > 0.5) {
        element.style.color = 'black';  // Light background
      } else {
        element.style.color = 'white';  // Dark background
      }
    }
  }, []);

  return (
    <>
      <div id='ele-281' className={`image-container divyansh inline-block rounded-md py-2 px-4 max-w-80 bg-primaryBgColor overflow-x-hidden max-w-image`}>

        <div className="absolute left-0 top-0 w-full h-[57px] rounded-md rounded-b-none fade-in-bottom p-4 text-center" style={{ background: design.themeColor || '#226CF4' }}
          id="dynamicText">
          <div id='ele-282' className="relative font-mSemiBold" >
            {iframeTitle}
            <div id='ele-283' className="absolute right-2 top-0 flex justify-end">
              {
                environment.viewType === 'launcher-icon'
                  ? screenSize === 'collapsed'
                    ? <OpenInFullIcon className="align-middle !text-xl m-auto text-white cursor-pointer" onClick={toggleScreenSize} />
                    : <CloseFullscreenIcon className="align-middle !text-xl m-auto text-white cursor-pointer" onClick={toggleScreenSize} />
                  : null
              }

              <CancelIcon className="!align-middle !text-2xl text-white cursor-pointer ml-4" onClick={handleClick} />

            </div>
          </div>
        </div>
        <div id='ele-284' className="absolute left-0 bottom-0 w-full h-[calc(100%-56px)] bg-white z-10 fade-in-bottom">
          {!isFrameLoaded && <LinearProgress sx={{
            backgroundColor: '#f0f0f0',
            '& .MuiLinearProgress-bar': {
              backgroundColor: '#a9a9a9',
            }
          }} />}
          <iframe id='ele-285' title={label} className="h-full w-full" src={'https://' + source} onLoad={frameLoaded}></iframe>
        </div>

      </div>
    </>
  );
}
